import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import './App.css';
import { ThemeProvider } from './ThemeContext';
import OSInterface from './components/OSInterface';
import AboutSection from './components/AboutSection';
import ProjectsSection from './components/ProjectsSection';
import ContactSection from './components/ContactSection';
import ExperienceSection from './components/ExperienceSection';
import SettingsSection from './components/SettingsSection';
import WorkWithMeSection from './components/WorkWithMeSection';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import ToDoPrivacyPolicy from './pages/ToDoPrivacyPolicy';
import ExcalidrawPage from './pages/ExcalidrawPage';

// Authentication Hell components
import AuthLayout from './authentication-hell/AuthLayout';
import AuthHome from './authentication-hell/AuthHome';
import Signup from './authentication-hell/Signup';
import SignupPin from './authentication-hell/SignupPin';
import SignupEmail from './authentication-hell/SignupEmail';
import SignupSecurity from './authentication-hell/SignupSecurity';
import SignupSuccess from './authentication-hell/SignupSuccess';
import Login from './authentication-hell/Login';
import LoginPin from './authentication-hell/LoginPin';
import LoginEmail from './authentication-hell/LoginEmail';
import LoginSecurity from './authentication-hell/LoginSecurity';
import LoginSuccess from './authentication-hell/LoginSuccess';
import DurationForGoogleTasks from './pages/DurationForGoogleTasks';

// OS Interface Main App
function MainApp() {
  return (
    <OSInterface>
      <AboutSection id="about" />
      <WorkWithMeSection id="work-with-me" />
      <ProjectsSection id="projects" />
      <ContactSection id="contact" />
      <ExperienceSection id="experience" />
      <SettingsSection id="settings" />
    </OSInterface>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppWithRouter />
    </ThemeProvider>
  );
}

// Fires an explicit $pageview on every React Router location change so SPA
// route transitions show up as pageviews even if PostHog's history listener
// misses one (e.g. replaceState, hash-only changes).
function PageviewTracker() {
  const location = useLocation();
  const posthog = usePostHog();
  useEffect(() => {
    if (!posthog) return;
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      pathname: location.pathname,
    });
  }, [location.pathname, location.search, posthog]);
  return null;
}

// Wrapper component to access Router
function AppWithRouter() {
  return (
    <Router>
      <PageviewTracker />
      <Routes>
        {/* Authentication Hell routes */}
        <Route path="/authentication-hell" element={<AuthLayout />}>
            <Route index element={<AuthHome />} />
            <Route path="signup" element={<Signup />} />
            <Route path="signup-pin" element={<SignupPin />} />
            <Route path="signup-email" element={<SignupEmail />} />
            <Route path="signup-security" element={<SignupSecurity />} />
            <Route path="signup-success" element={<SignupSuccess />} />
            <Route path="login" element={<Login />} />
            <Route path="login-pin" element={<LoginPin />} />
            <Route path="login-email" element={<LoginEmail />} />
            <Route path="login-security" element={<LoginSecurity />} />
            <Route path="login-success" element={<LoginSuccess />} />
          </Route>          
          {/* Power Tools for Google Tasks Pages - standalone pages without layout */}
          <Route path="duration_for_google_tasks/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="duration_for_google_tasks/terms-conditions" element={<TermsConditions />} />
          <Route path="duration-for-google-tasks" element={<DurationForGoogleTasks />} />
          
          {/* SimpleToDo App Privacy Policy */}
          <Route path="to-do-privacy-policy" element={<ToDoPrivacyPolicy />} />

          {/* Main OS Interface site */}
          <Route path="/" element={<MainApp />} />
          {/* Excalidraw page */}
          <Route path="/excalidraw" element={<ExcalidrawPage />} />
        </Routes>
      </Router>
  );
}

export default App;